import { filter, find, includes, isNull, isUndefined } from 'lodash'
import { FC, useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useAssistantDetailApiV1AssistantAssistantIdGet } from '../../../../api/gen/base'
import { FREE_MODEL_BY_DEFAULT } from '../../../../constants/constants'
import { useProfileStore } from '../../../../store/storeProfile'
import { useRequestsStore } from '../../../../store/storeRequests'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { validateFiles } from '../../RequestSettingPage/components/filesInRequest'
import { AgentOrAssistantButton } from './AgentOrAssistantButton'
import { AssistantSelectionDialog } from './AssistantSelectionDialog'

type Props = {
    requestId?: number
    isRequestsSetting?: boolean
    isDisabled?: boolean
    hideButton?: boolean
}

export const AgentOrAssistantSelect: FC<Props> = ({
    requestId,
    isRequestsSetting = false,
    isDisabled,
    hideButton,
}) => {
    const [isModelOrAssistantsUnavailable, setIsModelOrAssistantsUnavailable] = useState(undefined)
    const { pathname } = useLocation()
    const params = useParams()
    const { isFullAccess, userTariff, balance } = useProfileStore()

    const {
        setNameOpenDialog,
        nameOpenDialog,
        currentAssistantIdDialog,
        modelListActive,
        currentAgentNameInDialog,
        currentAssistantDataInDialog,
        setCurrentAgentAndAssistantIdDialog,
        setCurrentAssistantDataInDialog,
        modelDetail,
        assistantSubscriptions,
        isTempUser,
        modelListProtected,
        isProtectedCurrentProject,
    } = useWrapperStore((state) => state)
    const { requestDetail, setFilesError, setFilesInRequest, setFile, files } = useRequestsStore(
        (state) => state,
    )

    const isAssistantActive = currentAssistantIdDialog !== 'null' && !!currentAssistantIdDialog

    const {
        data: assistantData,
        error: assistantError,
        isFetching: isFetchingAssistant,
    } = useAssistantDetailApiV1AssistantAssistantIdGet(
        currentAssistantIdDialog,
        {},
        {},
        { query: { enabled: isAssistantActive } },
    )

    const handleClick = () => {
        setNameOpenDialog('AssistantSelectionDialog')
    }
    const handleCloseDialog = () => {
        setNameOpenDialog(undefined)
    }

    useEffect(() => {
        const resetModel = () => {
            setCurrentAgentAndAssistantIdDialog({
                agent: isFullAccess ? 'AUTO' : FREE_MODEL_BY_DEFAULT,
                assistantId: undefined,
            })
        }
        if (
            !isUndefined(balance) &&
            !isTempUser &&
            !isNull(currentAssistantIdDialog) &&
            !isNull(currentAgentNameInDialog) &&
            !params.requestId &&
            (!includes(
                userTariff?.tariff?.restrictions?.available_assistants,
                +requestDetail?.assistant_id,
            )
                ? false
                : filter(assistantSubscriptions, {
                        assistant_id: +requestDetail.assistant_id,
                    }).length === 0
                  ? true
                  : false ||
                    !includes(
                        userTariff?.tariff?.restrictions?.available_models,
                        currentAgentNameInDialog,
                    ))
        ) {
            resetModel()
        }

        if (!isUndefined(balance) && !isAssistantActive) {
            const isOpenMainPage = pathname.split('/')[1] === ''
            const shouldTryToResetModel = requestId === undefined && modelListActive

            if (shouldTryToResetModel) {
                const selectedModel = find(modelListActive, ['slug', currentAgentNameInDialog])

                if (
                    (isOpenMainPage && !currentAgentNameInDialog) ||
                    !selectedModel ||
                    selectedModel?.is_restricted
                ) {
                    resetModel()
                }
            } else if (!currentAgentNameInDialog) {
                resetModel()
            }
        }
    }, [
        requestId,
        modelListActive,
        isFullAccess,
        isAssistantActive,
        currentAgentNameInDialog,
        assistantSubscriptions,
        balance,
    ])

    useEffect(() => {
        setCurrentAssistantDataInDialog(isAssistantActive && assistantData ? assistantData : null)
    }, [assistantData, assistantError, currentAssistantIdDialog])

    useEffect(() => {
        if (params.requestId) {
            if (requestDetail && userTariff) {
                setIsModelOrAssistantsUnavailable(
                    !isTempUser &&
                        (requestDetail.assistant_id
                            ? includes(
                                  userTariff?.tariff?.restrictions?.available_assistants,
                                  +requestDetail?.assistant_id,
                              )
                                ? false
                                : filter(assistantSubscriptions, {
                                        assistant_id: +requestDetail.assistant_id,
                                    }).length === 0
                                  ? true
                                  : false
                            : !includes(
                                  userTariff?.tariff?.restrictions?.available_models,
                                  requestDetail?.agent,
                              )),
                )
            }
        } else {
            setIsModelOrAssistantsUnavailable(false)
        }
    }, [userTariff, requestDetail, params, assistantSubscriptions])


    useEffect(() => {
        if (
            currentAgentNameInDialog &&
            modelDetail &&
            modelDetail.slug === currentAgentNameInDialog &&
            files?.length > 0
        ) {
            setFilesError(null)
            const validationResult = validateFiles([...files], modelDetail?.supported_content)
            setFilesInRequest(undefined)
            setFile(validationResult.fileValidations)
            setFilesError(validationResult.isValid ? null : validationResult.errors)
        }
    }, [currentAgentNameInDialog, currentAssistantIdDialog, modelDetail])

    const displayButton = !!modelListActive && !isFetchingAssistant && !hideButton
    return (
        <>
            {displayButton && (
                <AgentOrAssistantButton
                    isAssistantActive={isAssistantActive}
                    isDisabled={isDisabled || isFetchingAssistant || isModelOrAssistantsUnavailable}
                    handleClick={handleClick}
                    modelList={isProtectedCurrentProject ? modelListProtected : modelListActive}
                    isRequestsSetting={isRequestsSetting}
                />
            )}
            {nameOpenDialog === 'AssistantSelectionDialog' && (
                <AssistantSelectionDialog
                    modelList={isProtectedCurrentProject ? modelListProtected : modelListActive}
                    requestId={requestId}
                    open={nameOpenDialog === 'AssistantSelectionDialog'}
                    handleClose={handleCloseDialog}
                />
            )}
        </>
    )
}
